import { useQuery } from "@tanstack/react-query";
import { moduleOptionTaskApi } from "./axios";
import {
  // DataI,
  // MigrationsI,
  // PropsI,
  ServiceResponseI,
  ModuleOptionI,
  OptionI,
  TaskMockI,
} from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

export const getAllTasksByModuleOptionKey = async (
  key: string,
): Promise<ServiceResponseI<TaskMockI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const params = new URLSearchParams();

    params.append("key", key.toString());

    const { data } = await moduleOptionTaskApi.get<
      ServiceResponseI<TaskMockI[]>
    >(`/all-tasks-by-module-option-key`, {
      params,
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const moduleOptionTaskPost = async <T>(getForms: T): Promise<string> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");
    const { data } = await moduleOptionTaskApi.post("", getForms, {
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const moduleOptionTaskPut = async <T>(
  id: number,
  updateForms: T,
): Promise<string> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");
    const { data } = await moduleOptionTaskApi.put(`/${id}`, updateForms, {
      headers: { Authorization: validateToken },
    });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};

export const moduleOptionTaskbyId = async (
  id: number,
): Promise<ServiceResponseI<ModuleOptionI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");
    const { data } = await moduleOptionTaskApi.get<
      ServiceResponseI<ModuleOptionI[]>
    >(`/all-by-id/${id}`, { headers: { Authorization: validateToken } });
    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) LogoutSystem();
    throw new Error((obj?.data as Error).message);
  }
};
